import { combineReducers } from 'redux';

import appReducer from './app/app.reducers';
import authReducer from './auth/auth.reducer';
import usersReducer from './users/users.reducer';


export default combineReducers({
	appReducer,
	authReducer,
	usersReducer
})



// WEBPACK FOOTER //
// ./src/state/reducersRoot.js